import React, { useEffect, memo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';

import styles from './SIMPop.module.less';
import { logging } from '../actions/log';
import { getIsSIMRunning, getIsSIMInstalled } from '../actions/asimstatus';

import {
  // 模拟器升级
  SIM_UPDATE_INSTALL_ING,
  // SIM_UPDATE_INSTALL_FINISHED,
  // SIM_UPDATE_INSTALL_FAILED,
} from '../constants/asimstatus';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectSIMProgress = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.progress,
);

const selectSIMStatus = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.status,
);

const selectSIMIsInstalled = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.issiminstalled,
);

const selectSIMIsRunning = createSelector(
  state => state.asimstatus,
  asimstatus => asimstatus.issimrunning,
);

const textRunning = [
  '正在为您准备模拟器环境',
  '安卓应用将通过模拟器运行',
  '大屏玩游戏，畅爽体验马上开始',
];

const textUpdating = [
  '模拟器升级中，请稍后',
  '等待过程中，您可以继续浏览',
  '大屏玩游戏，畅爽体验马上开始',
];

export default memo(() => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const SIMStatus = useSelector(selectSIMStatus); // 模拟器当前状态
  const SIMProgress = useSelector(selectSIMProgress); // 模拟器下载进度
  const SIMIsInstalled = useSelector(selectSIMIsInstalled); // 模拟器是否已经安装
  const SIMIsRunning = useSelector(selectSIMIsRunning); // 模拟器是否正在运行

  const [index, setIndex] = useState(0);
  const [showText, setShowText] = useState('正在准备应用运行环境');

  useEffect(() => {
    if (SIMStatus === SIM_UPDATE_INSTALL_ING) {
      setShowText(textUpdating[0]);
    }
  }, [SIMStatus]);

  useEffect(() => {
    dispatch(getIsSIMRunning());
    dispatch(getIsSIMInstalled());
  }, [dispatch]);

  useEffect(() => {
    // 快捷方式弹窗 PV
    dispatch(
      logging({
        category: 'P',
        action: 'A_SIMPop',
        label: '',
        param2: {
          source: 'A_SIMPop',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, [dispatch]);

  const onAnimationEndFunc = () => {
    const i = index + 1;
    setIndex(i);
    setShowText(textRunning[i % 3]);
  };

  const onAnimationEndFuncUpdate = () => {
    const i = index + 1;
    setIndex(i);
    setShowText(textUpdating[i % 3]);
  };

  return (
    SIMIsRunning === false && (
      <div className={styles.simpop}>
        <div className={styles.simpop_logo} />
        <div className={styles.simpop_des}>
          {/* 模拟器升级状态显示内容 */}
          {SIMStatus === SIM_UPDATE_INSTALL_ING ? (
            <div className={styles.simpop_info_simple}>
              <div
                className={styles.simpop_info_text}
                onAnimationIteration={() => onAnimationEndFuncUpdate()}
              >
                {showText}
              </div>
            </div>
          ) : (
            <React.Fragment>
              {/* 模拟器已经安装则不显示进度百分比数字 */}
              <div
                className={
                  SIMIsInstalled === false ? styles.simpop_info : styles.simpop_info_simple
                }
              >
                <div
                  className={styles.simpop_info_text}
                  onAnimationIteration={() => onAnimationEndFunc()}
                >
                  {showText}
                </div>
                {SIMIsInstalled === false && (
                  <div className={styles.simpop_info_num}>{`${SIMProgress || 0}%`}</div>
                )}
              </div>
              {/* 模拟器已经安装则不显示进度 */}
              {SIMIsInstalled === false && (
                <div className={styles.simpop_line}>
                  <div
                    className={styles.simpop_line_progress}
                    style={{ width: `${SIMProgress || 0}%` }}
                  />
                </div>
              )}
            </React.Fragment>
          )}
        </div>
      </div>
    )
  );
});
